import { AddressModel } from './address.model';
import { BaseModel } from './base.model';
import { ImageModel } from './image.model';
import { ContactModel } from './contact.model';
import { environment } from '../../../environments/environment';

export class CompanyModel extends BaseModel {

  static DISPLAY_TENANT = 'tenant';
  static DISPLAY_FM_PROVIDER = 'fm-provider';

  static MODAL_LOCATION_ALL = 0;
  static MODAL_LOCATION_SUCCESS_CHECKIN = 1;
  static MODAL_LOCATION_DIAL_TENANT = 2;

  id: number;
  name: string;
  elevatorGroup: string;
  meetingBufferHours: number;
  receptionNumber: string;
  receptionText: string;
  receptionInstance: string;
  receptionDisplay: string;
  isOnDisplay: 0 | 1;
  hasSuccessModal: boolean;
  successModalLocation: 0 | 1 | 2;
  successModalTitle: { [lang: string]: string };
  successModalBody: { [lang: string]: string };

  defaultPhotoUrl: string = './assets/images/placeholder-image.png';

  image: ImageModel;
  contacts: ContactModel[];
  allowedDomains: CompanyDomainModel[];
  address: AddressModel;
  imageFile?: File;

  get childModels(): {} {
    return {
      image: ImageModel,
      address: AddressModel,
      contacts: ContactModel,
      allowedDomains: CompanyDomainModel
    };
  }

  toApi(model?: this): {} {
    const source = model || this;

    return {
      ...super.toApi(model),
      ...((model && model.imageFile) ? { image_file: model.imageFile } : {}),
      ...(source.successModalTitle ? { success_modal_title: JSON.stringify(source.successModalTitle) } : {}),
      ...(source.successModalBody ? { success_modal_body: JSON.stringify(source.successModalBody) } : {}),
    };
  }

  get thumbUrl() {
    return this.image?.baseUrl || this.defaultPhotoUrl;
  }

  static get availableReceptionDisplays() {
    return [
      { id: CompanyModel.DISPLAY_TENANT, name: 'Main Display' },
      { id: CompanyModel.DISPLAY_FM_PROVIDER, name: 'Help Display' },
    ];
  }

  static get availableSuccessModalLocations() {
    return [
      { id: CompanyModel.MODAL_LOCATION_ALL, name: 'All locations' },
      { id: CompanyModel.MODAL_LOCATION_SUCCESS_CHECKIN, name: 'Successful check-in' },
      { id: CompanyModel.MODAL_LOCATION_DIAL_TENANT, name: 'Dial tenant modal' },
    ];
  }

  isOnTenantDisplay() {
    return this.receptionDisplay == CompanyModel.DISPLAY_TENANT;
  }

}

export class CompanyDomainModel extends BaseModel {
  id: number;
  companyId: number;
  domain: string;
  receptionEmail: string;

  get unsafeApiAttributes() {
    return [];
  }
}
